import { render, staticRenderFns } from "./UnhandledRecruitmentAlertSymbol.vue?vue&type=template&id=4d556fe2&"
import script from "./UnhandledRecruitmentAlertSymbol.vue?vue&type=script&lang=ts&"
export * from "./UnhandledRecruitmentAlertSymbol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./UnhandledRecruitmentAlertSymbol.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
